<template>
  <el-config-provider :locale="locale">
  <router-view/>
</el-config-provider>
</template>

<script>

import {ElConfigProvider} from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
export default {
  name: 'App',   //这里改成你自己的名称
  components: {
    [ElConfigProvider.name]:ElConfigProvider,//添加组件
  },
 
  data(){
      return{
          locale:zhCn,//给locale赋值
        }
    }
}
</script>
<style>
  body{
  margin: 0;
  padding:0;
}
</style>
